<template>
    <div>  
    <component :is="$router.currentRoute.query.chart" :chart-data="drillChartData.chartData" @drilldown="openDrilldown" />
    <div class="mt-2">
        <h4>{{ $router.currentRoute.query.drilldown}}</h4>
    </div>
    <div class="mt-5">
        <v-data-table
        id="designations"
        :headers="headers"
        :items="tableData"
        hide-default-footer
      />
      <div class="primary-icon">
        <license-pagination
          :total="total"
          :value="page"
          @input="pageEmit"
        />
      </div>
    </div>
</div>
</template>

<script>
import { mapActions } from 'vuex'
import licensePagination from '@/components/LicensePagination/licensePagination.vue';
import EarlyChurnRate from './EarlyChurnRate.vue'
import NoOfSignups from './NoOfSignups.vue'
import DirectUsers from './DirectUsers.vue';
import ConversionRate from './ConversionRate.vue';
import AvgUser from './AvgUser.vue';
export default {
    components:{
        NoOfSignups,
        EarlyChurnRate,
        licensePagination,
        DirectUsers,
        ConversionRate,
        AvgUser
    },
    props: {
        drillChartData: {
            type: Object,
            required: true
        },
        timeFilter:{
            type:Object,
            required:true
        }
    },
    data(){
        return{
        tableData:[],
        total:0,
        page:1
    }
},
computed:{
headers(){
    if(this.tableData.length){   
   return Object.keys(this.tableData[0]).map(el=>({ text: el,
        align: 'start',
        value: el,}))
   }
   else return [] 
}
},
    async mounted(){
        console.log(this.$router.currentRoute)
        this.getchartData()
    },
    methods:{
    async getchartData(){
        if(this.$router.currentRoute.query.chart==='NoOfSignups'){
         this.getSignupData({payLoad: {
                type: "data",
                timefilter: this.timeFilter,
                date:this.$router.currentRoute.query.drilldown
            },page:this.page,limit:10}).then(res=>{
                if(res.status===200){
                    this.total=res.data.totalCount
                    this.tableData=res.data.data
                }
            })
        }
        if(this.$router.currentRoute.query.chart==='EarlyChurnRate'){
            await this.getEarlyChurnRate({
            payLoad: {
                type: "data",
                timefilter: this.timeFilter,
                date:this.$router.currentRoute.query.drilldown
            },page:this.page,limit:10
        }).then(res => {
            if (res.status === 200) {
           
                this.total=res.data.totalCount
                this.tableData = res.data.data;
         
            }
        });
        }
        if(this.$router.currentRoute.query.chart === 'DirectUsers'){
            await this.getDirectSignups({
            payLoad: {
                type: "data",
                timefilter: this.timeFilter,
                date:this.$router.currentRoute.query.drilldown
            },page:this.page,limit:10
        }).then(res => {
            if (res.status === 200) {
                this.total=res.data.totalCount
                this.tableData = res.data.data;
            }
        });
        }
        if(this.$router.currentRoute.query.chart === 'ConversionRate'){
            await this.getPaidConversionRate({
            payLoad: {
                type: "data",
                timefilter: this.timeFilter,
                
            },page:this.page,limit:10
        }).then(res => {
            if (res.status === 200) {
                this.total=res.data.totalCount
                this.tableData = res.data.data;
            }
        });
        }
        if(this.$router.currentRoute.query.chart === 'AvgUser'){
            await this.getAvgUsers({
            payLoad: {
                type: "data",
                timefilter: this.timeFilter,
                
            },page:this.page,limit:10
        }).then(res => {
            if (res.status === 200) {
                this.total=res.data.totalCount
                this.tableData = res.data.data;
            }
        });
        }
    },
    pageReset() {
      if (this.search) {
        this.page = 1;
      }
    },
    pageEmit(data) {
      if (data > 0) this.page = data;
      this.getchartData()
    },
        ...mapActions({
            getSignupData: "Marketing/getSignupData",
            getDirectSignups: "Marketing/getDirectSignups",
            getEarlyChurnRate: "Marketing/getEarlyChurnRate",
            getPaidConversionRate: "Marketing/getPaidConversionRate",
            getAvgUsers: "Marketing/getAvgUsers"
        }),
        openDrilldown(params){
            this.isDrilldown=true
            this.$router.push(`${this.$router.currentRoute.path}?chart=${params.chart}&drilldown=${params.value}`)
        }
    }
}
</script>